<template>
  <div>
    <table class="table-status">
      <tr class="table-header">
        <th colspan="5"> House </th>
        <th colspan="5"> Senate </th>
        <th colspan="4"> Joint </th>
      </tr>
      <tr class="status-cell">
        <StatusCell :action="houseStatuses.one" :bill="bill">1</StatusCell>
        <StatusCell :action="houseStatuses.C" :bill="bill">C</StatusCell>
        <!-- <StatusCell :action="houseStatuses.R" :bill="bill">R</StatusCell> -->
        <StatusCell :action="houseStatuses.W" :bill="bill">W</StatusCell>
        <StatusCell :action="houseStatuses.two" :bill="bill">2</StatusCell>
        <StatusCell :action="houseStatuses.three" :bill="bill">3</StatusCell>

        <StatusCell :action="senateStatuses.one" :bill="bill">1</StatusCell>
        <StatusCell :action="senateStatuses.C" :bill="bill">C</StatusCell>
        <!-- <StatusCell :action="senateStatuses.R" :bill="bill">R</StatusCell> -->
        <StatusCell :action="senateStatuses.W" :bill="bill">W</StatusCell>
        <StatusCell :action="senateStatuses.two" :bill="bill">2</StatusCell>
        <StatusCell :action="senateStatuses.three" :bill="bill">3</StatusCell>

        <StatusCell :action="lsoStatuses.J" :bill="bill">J</StatusCell>
        <StatusCell :action="houseStatuses.J" :bill="bill">H</StatusCell>
        <StatusCell :action="senateStatuses.J" :bill="bill">S</StatusCell>
        <StatusCell :action="govStatuses.J" :bill="bill">G</StatusCell>
      </tr>
    </table></div
  >
</template>
<script>
import StatusCell from '@components/lso/StatusCell'

export default {
  //model: {
  //	prop: ''
  //},
  props: {
    bill: {
      type: Object,
      default: {},
    },
  },
  components: { StatusCell },
  filters: {},
  data() {
    return {}
  },
  created() {},
  computed: {
    billActions() {
      return this.bill.billActions.map((ba) => {
        return {
          ...ba,
          statusDate: new Date(ba.statusDate),
        }
      })
    },
    houseActions() {
      return this.billActions
        .filter((item) => {
          return item.location == 'House'
        })
        .sort((a, b) => b.statusDate - a.statusDate)
    },
    senateActions() {
      return this.billActions
        .filter((item) => {
          return item.location == 'Senate'
        })
        .sort((a, b) => b.statusDate - a.statusDate)
    },
    govActions() {
      return this.billActions
        .filter((item) => {
          return item.location == 'Governor'
        })
        .sort((a, b) => b.statusDate - a.statusDate)
    },
    lsoActions() {
      return this.billActions
        .filter((item) => {
          return item.location == 'LSO'
        })
        .sort((a, b) => b.statusDate - a.statusDate)
    },
    houseStatuses() {
      return {
        one: this.houseActions.find(
          (item) =>
            item.statusMessage
              .toLowerCase()
              .includes('did not consider for introduction') ||
            item.statusMessage.toLowerCase().includes('failed introduction') ||
            item.statusMessage.toLowerCase().includes('withdrawn') ||
            item.statusMessage
              .toLowerCase()
              .includes('introduced and referred to ')
        ),
        two: this.houseActions.find((item) =>
          item.statusMessage.toLowerCase().includes('2nd reading')
        ),
        three: this.houseActions.find((item) =>
          item.statusMessage.toLowerCase().includes('3rd reading')
        ),
        W: this.houseActions.find(
          (item) =>
            item.statusMessage.toLowerCase().includes('cow:passed') ||
            item.statusMessage
              .toLowerCase()
              .includes('did not consider for cow') ||
            item.statusMessage.toLowerCase().includes('cow:failed')
        ),
        C: this.houseActions.find(
          (item) =>
            item.statusMessage.toLowerCase().includes('died in committee') ||
            item.statusMessage.toLowerCase().includes(':do pass failed') ||
            item.statusMessage.toLowerCase().includes(':recommend')
        ),
        R: this.houseActions.find(
          (item) =>
            item.statusMessage.toLowerCase().includes(':recommend do pass') ||
            item.statusMessage
              .toLowerCase()
              .includes(':recommend amend and do pass')
        ),
        J: this.houseActions.find((item) =>
          item.statusMessage.toLowerCase().includes('speaker signed')
        ),
      }
    },
    senateStatuses() {
      return {
        one: this.senateActions.find(
          (item) =>
            item.statusMessage
              .toLowerCase()
              .includes('did not consider for introduction') ||
            item.statusMessage.toLowerCase().includes('failed introduction') ||
            item.statusMessage.toLowerCase().includes('withdrawn') ||
            item.statusMessage
              .toLowerCase()
              .includes('introduced and referred to ')
        ),
        two: this.senateActions.find((item) =>
          item.statusMessage.toLowerCase().includes('2nd reading')
        ),
        three: this.senateActions.find((item) =>
          item.statusMessage.toLowerCase().includes('3rd reading')
        ),
        W: this.senateActions.find(
          (item) =>
            item.statusMessage.toLowerCase().includes('cow:passed') ||
            item.statusMessage
              .toLowerCase()
              .includes('did not consider for cow') ||
            item.statusMessage.toLowerCase().includes('cow:failed')
        ),
        C: this.senateActions.find(
          (item) =>
            item.statusMessage.toLowerCase().includes('died in committee') ||
            item.statusMessage.toLowerCase().includes(':do pass failed') ||
            item.statusMessage.toLowerCase().includes(':recommend')
        ),
        R: this.senateActions.find(
          (item) =>
            item.statusMessage.toLowerCase().includes(':recommend do pass') ||
            item.statusMessage
              .toLowerCase()
              .includes(':recommend amend and do pass')
        ),
        J: this.senateActions.find((item) =>
          item.statusMessage.toLowerCase().includes('president signed')
        ),
      }
    },
    lsoStatuses() {
      return {
        J: this.lsoActions.find((item) =>
          item.statusMessage.toLowerCase().includes('assigned number')
        ),
      }
    },
    govStatuses() {
      return {
        J: this.govActions.find(
          (item) =>
            item.statusMessage.toLowerCase().includes('vetoed') ||
            item.statusMessage.toLowerCase().includes(`governor's signature`) ||
            item.statusMessage.toLowerCase().includes('governor signed')
        ),
      }
    },
  },
  methods: {
    getCellClass() {},
  },
  watch: {},
}
</script>
<style scoped>
.status-cell td {
  width: 25px;
  height: 25px;
  border: 1px solid black;
  color: black !important;
}
.table-header th {
  border-left: 1px solid black;
  border-bottom: 1px solid black;
  background-color: transparent;
  margin: 0px;
}
.table-header th:first-child {
  border-left: 0px;
}
.table-status {
  border-collapse: collapse;
  border: 0px;
  /* width: 100%; */
  background-color: transparent;
  margin: 0;
  text-align: center;
}
</style>